import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Add, Check, Close, Edit } from '@mui/icons-material';
import { Box, IconButton, TextField as MuiTextField, Typography } from '@mui/material';
import React from 'react';
export function InlineTextField(props) {
    const { value, onChange, placeholder = 'Click to edit', multiline = false, canEdit = false, variant = 'body1', } = props;
    const [isEditing, setIsEditing] = React.useState(false);
    const [editValue, setEditValue] = React.useState(value);
    const inputRef = React.useRef(null);
    React.useEffect(() => {
        if (!isEditing) {
            setEditValue(value);
        }
    }, [value, isEditing]);
    React.useEffect(() => {
        if (isEditing && inputRef.current) {
            inputRef.current.focus();
            inputRef.current.select();
        }
    }, [isEditing]);
    const handleStartEdit = React.useCallback(() => {
        if (canEdit) {
            setEditValue(value);
            setIsEditing(true);
        }
    }, [canEdit, value]);
    const handleSave = React.useCallback(() => {
        onChange(editValue);
        setIsEditing(false);
    }, [editValue, onChange]);
    const handleCancel = React.useCallback(() => {
        setEditValue(value);
        setIsEditing(false);
    }, [value]);
    const handleKeyDown = React.useCallback((event) => {
        if (event.key === 'Escape') {
            handleCancel();
        }
        else if (event.key === 'Enter' && !multiline) {
            event.preventDefault();
            handleSave();
        }
    }, [handleCancel, handleSave, multiline]);
    if (isEditing) {
        return (_jsxs(Box, { sx: { display: 'flex', alignItems: 'flex-start', gap: 0.5 }, children: [_jsx(MuiTextField, { inputRef: inputRef, value: editValue, onChange: (e) => setEditValue(e.target.value), onKeyDown: handleKeyDown, placeholder: placeholder, multiline: multiline, minRows: multiline ? 2 : undefined, maxRows: multiline ? 8 : undefined, size: "small", fullWidth: true, variant: "outlined" }), _jsx(IconButton, { size: "small", onClick: handleSave, color: "primary", "aria-label": "save", children: _jsx(Check, { fontSize: "small" }) }), _jsx(IconButton, { size: "small", onClick: handleCancel, "aria-label": "cancel", children: _jsx(Close, { fontSize: "small" }) })] }));
    }
    const displayValue = value || placeholder;
    const isPlaceholder = !value;
    return (_jsxs(Box, { sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            cursor: canEdit ? 'pointer' : 'default',
            '&:hover': canEdit
                ? {
                    backgroundColor: 'action.hover',
                    borderRadius: 1,
                }
                : {},
            padding: 0.5,
            marginLeft: -0.5,
            borderRadius: 1,
        }, onClick: handleStartEdit, children: [_jsx(Typography, { variant: variant, sx: {
                    color: isPlaceholder ? 'text.disabled' : 'text.primary',
                    fontStyle: isPlaceholder ? 'italic' : 'normal',
                    whiteSpace: multiline ? 'pre-wrap' : 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    flexGrow: 1,
                }, children: displayValue }), canEdit &&
                (isPlaceholder ? (_jsx(Add, { fontSize: "small", sx: {
                        color: 'action.active',
                        opacity: 0.5,
                        '&:hover': { opacity: 1 },
                    } })) : (_jsx(Edit, { fontSize: "small", sx: {
                        color: 'action.active',
                        opacity: 0.5,
                        '&:hover': { opacity: 1 },
                    } })))] }));
}
//# sourceMappingURL=InlineTextField.js.map